export const adminManager = {
    "admin_manager_title": "超级管理员面板",
    "admin_manager_tab_Group": "用户组",
    "admin_manager_tab_Users": "教师管理",
    "admin_manager_tab_Students": "学生管理",
    "admin_manager_tab_Classes": "班级管理",
    "admin_manager_tab_TeachingLocation": "校区",
    "admin_manager_tab_Subject": "学科",
    "admin_manager_tab_WorkingTimeSheet": "工时单",
    "admin_manager_tab_RegisterCoder": "邀请码",
};

export const registerCoder = {
    "register_code_invitation_code": "邀请码",
    "register_code_status": "是否可用",
    "register_code_disabled": "禁用",
    "register_code_enabled": "可用",
    "register_code_expiry_time": "过期时间",
    "register_code_days_right": "180 天",
    "register_code_days_left": "{{days}} 天",
    "register_code_remaining_invites": "剩余邀请次数",
    "register_code_people": "{{count}} 人",
    "register_code_max_people": "15 人",
    "register_code_copy": "复制",
    "register_code_enable": "启用",
    "register_code_disable": "禁用",
    "register_code_reset": "重置",
    "register_code_delete": "删除",
    "register_code_confirm_delete": "确定要删除吗？",
    "register_code_create": "创建",
    "register_code_copy_success": "复制成功",
    "register_code_action": "操作"
};

export const timesheetList = {
    "timesheet_list_title_name": "名称",
    "timesheet_list_title_title": "标题",
    "timesheet_list_title_target_audience": "目标用户",
    "timesheet_list_tag_none": "无",
    "timesheet_list_title_submission_period": "提交周期",
    "timesheet_list_weeks": "{{weeks}} 周",
    "timesheet_list_title_grace_days": "截止后宽限期",
    "timesheet_list_grace_days": "+{{days}} 天",
    "timesheet_list_title_version": "版本",
    "timesheet_list_version_tag": "v{{ver}}",
    "timesheet_list_action": "操作",
    "timesheet_list_action_view": "查看",
    "timesheet_list_action_update": "更新",
    "timesheet_list_action_delete": "删除",
    "timesheet_list_confirm_delete_title": "确定要删除此考核问卷吗？",
    "timesheet_list_confirm_delete_content": "此操作无法撤销。",
    "timesheet_list_confirm_ok": "是",
    "timesheet_list_confirm_cancel": "否",
    "timesheet_list_create_button": "创建",
    "timesheet_list_modal_title_create": "创建考核问卷",
    "timesheet_list_modal_title_update": "更新考核问卷：{{name}}",
    "timesheet_list_success_delete": "考核问卷删除成功！",
    "timesheet_list_error_delete": "删除考核问卷失败"
};

export const groupManager = {
    "group_manager_create_button": "创建用户组",
    "group_manager_modal_create_title": "创建用户组",
    "group_manager_form_label_name": "用户组名称",
    "group_manager_form_placeholder": "请输入用户组名称",
    "group_manager_modal_cancel": "取消",
    "group_manager_modal_create_confirm": "创建",
    "group_manager_modal_delete_title": "删除用户组",
    "group_manager_confirm_delete_message": "确定要删除用户组 {{id}} 吗？",
    "group_manager_modal_delete_confirm": "删除",
    "group_manager_table_header_id": "ID",
    "group_manager_table_header_name": "名称",
    "group_manager_table_header_user_count": "用户数量",
    "group_manager_table_header_actions": "操作",
    "group_manager_action_add_users": "添加/移除用户",
    "group_manager_action_delete_group": "删除用户组"
};

export const managerLocation = {
    "teaching_location_add_button": "添加教学地点",
    "teaching_location_modal_title": "添加教学地点",
    "teaching_location_column_name": "名称",
    "teaching_location_column_remark": "备注",
    "teaching_location_column_action": "操作",
    "teaching_location_delete_confirm": "确定要删除吗？",
    "teaching_location_delete_button": "删除",
    "teaching_location_form_label_name": "名称",
    "teaching_location_form_label_remark": "备注",
    "teaching_location_form_required_name": "请输入名称",
    "teaching_location_msg_add_success": "添加成功",
    "teaching_location_msg_add_failed": "添加失败",
    "teaching_location_msg_delete_success": "删除成功",
    "teaching_location_msg_delete_failed": "删除失败",
    "teaching_location_msg_fetch_failed": "加载教学地点失败"
};

export const TeachingSubjectManager = {
    "teaching_course_add_button": "添加教学科目",
    "teaching_course_modal_title": "添加教学科目",
    "teaching_course_column_name": "名称",
    "teaching_course_column_action": "操作",
    "teaching_course_delete_confirm": "确定要删除该教学科目吗？",
    "teaching_course_delete_button": "删除",
    "teaching_course_form_label_name": "名称",
    "teaching_course_form_required_name": "请输入教学科目名称",
    "teaching_course_msg_fetch_failed": "加载教学科目失败",
    "teaching_course_msg_add_success": "教学科目添加成功",
    "teaching_course_msg_add_failed": "教学科目添加失败",
    "teaching_course_msg_delete_success": "教学科目删除成功",
    "teaching_course_msg_delete_failed": "教学科目删除失败"
};

export const UsersManager = {
    "user_manager_tab_base_users": "Tutors",
    "user_manager_tab_pending_users": "待离职",
    "user_manager_tab_terminated_users": "已离职",
    "terminated_users_table_column_index": "序号",
    "terminated_users_table_column_name": "姓名",
    "terminated_users_table_column_terminated_time": "离职时间",
    "pending_users_column_index": "序号",
    "pending_users_column_name": "姓名",
    "pending_users_column_last_login": "最后登录时间",
    "pending_users_column_expected_terminate_time": "预计离职日期",
    "pending_users_column_action": "操作",
    "pending_users_action_resume": "恢复",
    "pending_users_action_terminate": "离职",
    "pending_users_confirm_resume_title": "恢复 {{name}}？",
    "pending_users_confirm_resume_content": "{{name}} 将其恢复任职状态。",
    "pending_users_confirm_terminate_title": "永久离职 {{name}}？",
    "pending_users_confirm_terminate_content": "此操作不可撤销。{{name}} 将被永久移出系统。",
    "pending_users_msg_resume_success": "{{name}} 已成功恢复。",
    "pending_users_msg_resume_error": "恢复 {{name}} 失败。",
    "pending_users_msg_terminate_success": "{{name}} 已成功离职。",
    "pending_users_msg_terminate_error": "离职 {{name}} 失败。",
    "base_users_column_id": "ID",
    "base_users_column_name": "姓名",
    "base_users_column_last_login": "最后登录时间",
    "base_users_column_auth": "角色",
    "base_users_column_mark_name": "备注名",
    "base_users_column_actions": "操作",
    "base_users_action_rename": "重命名",
    "base_users_action_terminate": "标记离职",
    "base_users_modal_rename_title": "设置备注名",
    "base_users_modal_rename_placeholder": "请输入备注名",
    "base_users_select_roles_placeholder": "选择角色",
    "base_users_confirm_terminate_title": "标记 {{name}} 为待离职？",
    "base_users_confirm_terminate_content_p1": "该用户将不再出现在共享文件列表或查询结果中。",
    "base_users_confirm_terminate_content_p2": "你仍可在`待离职`列表中找到该用户。",
    "base_users_confirm_terminate_content_p3": "该用户将在 7 天后被永久删除。",
    "base_users_confirm_terminate_content": "该用户将从共享文件和查询结果中隐藏，并出现在`待离职`列表中，7天后将被永久删除。",
    "base_users_msg_fetch_error": "加载用户失败。",
    "base_users_msg_update_auth_success": "角色更新成功。",
    "base_users_msg_update_auth_error": "角色更新失败。",
    "base_users_msg_mark_terminate_success": "{{name}} 已标记为待离职。",
    "base_users_msg_mark_terminate_error": "标记 {{name}} 为待离职失败。",
    "base_users_msg_update_mark_name_success": "备注名更新成功。",
    "base_users_msg_update_mark_name_error": "备注名更新失败。",
};

export const studentManager = {
    "student_manager_msg_fetch_error": "获取学生列表失败",
    "student_manager_msg_create_success": "创建学生成功",
    "student_manager_msg_create_error": "创建学生失败",
    "student_manager_msg_name_required": "请填写姓名",
    "student_manager_msg_course_location_required": "请选择校区",
    "student_manager_msg_update_success": "更新学生成功",
    "student_manager_msg_update_error": "更新学生失败",
    "student_manager_msg_delete_success": "删除学生成功",
    "student_manager_msg_delete_error": "删除学生失败",
    "student_manager_msg_disable_success": "操作成功",
    "student_manager_msg_disable_error": "操作失败",
    "student_manager_msg_reset_password_success": "重置密码成功",
    "student_manager_msg_reset_password_error": "重置密码失败",
    "student_manager_search_placeholder": "搜索姓名或邮箱",
    "student_manager_filter_location_placeholder": "选择校区",
    "student_manager_search_button": "搜索",
    "student_manager_create_button": "创建学生",
    "student_manager_column_id": "ID",
    "student_manager_column_name": "姓名",
    "student_manager_column_email": "邮箱",
    "student_manager_column_first_name": "名",
    "student_manager_column_last_name": "姓",
    "student_manager_column_remark_name": "备注名",
    "student_manager_column_course_location": "校区",
    "student_manager_column_status": "状态",
    "student_manager_column_init_password": "初始密码",
    "student_manager_column_login_time": "最后登录时间",
    "student_manager_column_actions": "操作",
    "student_manager_status_active": "正常",
    "student_manager_status_disabled": "已禁用",
    "student_manager_action_edit": "编辑",
    "student_manager_action_reset_password": "重置密码",
    "student_manager_action_disable": "禁用",
    "student_manager_action_enable": "启用",
    "student_manager_action_delete": "删除",
    "student_manager_action_permanent_delete": "彻底删除",
    "student_manager_view_active": "正常学生",
    "student_manager_view_deleted": "已删除",
    "student_manager_status_deleted": "已删除",
    "student_manager_column_deleted_at": "删除时间",
    "student_manager_confirm_delete_title": "确定要删除学生 {{name}} 吗？",
    "student_manager_confirm_delete_content": "学生将被移入已删除列表，可在「已删除」视图中查看。",
    "student_manager_confirm_permanent_delete_title": "确定要彻底删除学生 {{name}} 吗？",
    "student_manager_confirm_permanent_delete_content": "此操作将永久删除该学生记录，无法恢复。",
    "student_manager_msg_permanent_delete_success": "学生已彻底删除",
    "student_manager_msg_permanent_delete_error": "彻底删除学生失败",
    "student_manager_confirm_disable_title": "确定要{{action}}学生 {{name}} 吗？",
    "student_manager_confirm_disable_content": "此操作将改变学生的状态。",
    "student_manager_modal_create_title": "创建学生",
    "student_manager_modal_edit_title": "编辑学生：{{name}}",
    "student_manager_modal_reset_password_title": "重置密码：{{name}}",
    "student_manager_form_label_name": "姓名",
    "student_manager_form_label_email": "邮箱",
    "student_manager_form_label_first_name": "名",
    "student_manager_form_label_last_name": "姓",
    "student_manager_form_label_remark_name": "备注名",
    "student_manager_form_label_course_location": "校区",
    "student_manager_form_label_remark": "备注",
    "student_manager_form_label_init_password": "初始密码",
    "student_manager_form_label_new_password": "新密码",
    "student_manager_form_label_optional": "（可选）",
    "student_manager_create_form_hint": "姓名和校区为必填项，其他字段为可选项，可不填。",
    "student_manager_form_optional_empty": "当前未填写，可不填",
    "student_manager_form_optional_filled": "已填写",
    "student_manager_form_placeholder_name": "请输入姓名",
    "student_manager_form_placeholder_email": "请输入邮箱",
    "student_manager_form_placeholder_first_name": "请输入名",
    "student_manager_form_placeholder_last_name": "请输入姓",
    "student_manager_form_placeholder_remark_name": "请输入备注名",
    "student_manager_form_placeholder_course_location": "请选择校区",
    "student_manager_form_placeholder_remark": "请输入备注",
    "student_manager_form_placeholder_init_password": "留空则使用全局默认密码",
    "student_manager_form_placeholder_new_password": "留空则使用全局默认密码",
    "student_manager_form_hint_password": "留空则使用全局默认密码；学生未修改初始密码时将重置初始密码，已修改则重置登录密码",
    "student_manager_default_init_password_button": "全局初始密码",
    "student_manager_modal_default_init_password_title": "设置全局初始密码",
    "student_manager_default_init_password_desc": "设置后，创建学生时若不填写初始密码，将自动使用此密码。可设置为任意合法字符串，长度不限。",
    "student_manager_default_init_password_reminder": "已配置全局初始密码，留空时将自动使用：{{password}}",
    "student_manager_msg_default_init_password_save_success": "全局初始密码保存成功",
    "student_manager_msg_default_init_password_save_error": "全局初始密码保存失败",
    "student_manager_table_total": "共 {{total}} 条",
};

export const classManager = {
    "class_manager_msg_fetch_error": "获取班级列表失败",
    "class_manager_msg_create_success": "创建班级成功",
    "class_manager_msg_create_error": "创建班级失败",
    "class_manager_msg_update_status_success": "更新班级状态成功",
    "class_manager_msg_update_status_error": "更新班级状态失败",
    "class_manager_msg_delete_success": "删除班级成功",
    "class_manager_msg_delete_error": "删除班级失败",
    "class_manager_msg_copy_success": "复制班级成功",
    "class_manager_msg_copy_error": "复制班级失败",
    "class_manager_msg_date_required": "请选择开始和结束日期",
    "class_manager_msg_init_can_only_change_to_running": "初始化状态只能切换到进行中",
    "class_manager_msg_cannot_change_to_init": "无法切换回初始化状态",
    "class_manager_status_hint_init_only_running": "初始化状态只能切换到进行中",
    "class_manager_search_placeholder": "搜索班级名称",
    "class_manager_filter_status_placeholder": "选择状态",
    "class_manager_search_button": "搜索",
    "class_manager_create_button": "创建班级",
    "class_manager_loading": "加载中...",
    "class_manager_no_data": "暂无数据",
    "class_manager_status_init": "初始化",
    "class_manager_status_running": "进行中",
    "class_manager_status_end": "已结束",
    "class_manager_status_disabled": "已禁用",
    "class_manager_action_view": "查看",
    "class_manager_action_copy": "复制",
    "class_manager_action_delete": "删除",
    "class_manager_confirm_delete_title": "确定要删除班级 {{name}} 吗？",
    "class_manager_confirm_delete_content": "此操作无法撤销。",
    "class_manager_confirm_copy_title": "确定要复制班级 {{name}} 吗？",
    "class_manager_confirm_copy_content": "将创建一个新的班级副本。",
    "class_manager_confirm_change_status_title": "确定要将班级状态切换为 {{status}} 吗？",
    "class_manager_confirm_change_status_content": "班级 {{name}} 将被设置为 {{status}} 状态，此操作需要谨慎。",
    "class_manager_modal_create_title": "创建班级",
    "class_manager_modal_view_title": "班级详情：{{name}}",
    "class_manager_modal_close": "关闭",
    "class_manager_form_label_name": "班级名称",
    "class_manager_form_label_desc": "描述",
    "class_manager_form_label_date_range": "预计授课时间",
    "class_manager_form_hint_date_range": "留空则默认为当年年初至3年后",
    "class_manager_form_label_status": "状态",
    "class_manager_form_placeholder_name": "请输入班级名称",
    "class_manager_form_placeholder_desc": "请输入班级描述",
    "class_manager_card_start_time": "开始时间",
    "class_manager_card_end_time": "结束时间",
    "class_manager_detail_name": "班级名称",
    "class_manager_detail_desc": "描述",
    "class_manager_detail_status": "状态",
    "class_manager_detail_start_time": "开始时间",
    "class_manager_detail_end_time": "结束时间",
    "class_manager_detail_created_at": "创建时间",
    "class_manager_detail_updated_at": "更新时间",
    "class_manager_table_total": "共 {{total}} 条",
    "class_manager_table_page": "第 {{page}} / {{total}} 页",
    "class_manager_table_prev": "上一页",
    "class_manager_table_next": "下一页",
    "class_manager_view_card": "卡片",
    "class_manager_view_list": "列表",
    "class_manager_action_edit": "编辑",
    "class_manager_action_add_person": "添加人员",
    "class_manager_msg_update_success": "更新班级成功",
    "class_manager_msg_update_error": "更新班级失败",
    "class_manager_msg_fetch_users_error": "获取用户列表失败",
    "class_manager_msg_select_user": "请选择用户",
    "class_manager_msg_add_person_success": "添加人员成功",
    "class_manager_msg_add_person_error": "添加人员失败",
    "class_manager_msg_remove_person_success": "移除人员成功",
    "class_manager_msg_remove_person_error": "移除人员失败",
    "class_manager_msg_fetch_detail_error": "获取班级详情失败",
    "class_manager_modal_edit_title": "编辑班级：{{name}}",
    "class_manager_modal_add_person_title": "添加人员到班级：{{name}}",
    "class_manager_modal_add_teachers_title": "添加老师到班级：{{name}}",
    "class_manager_form_label_person_type": "人员类型",
    "class_manager_person_type_teacher": "老师",
    "class_manager_person_type_student": "学生",
    "class_manager_form_label_select_teacher": "选择老师",
    "class_manager_form_label_select_student": "选择学生",
    "class_manager_form_placeholder_select_teacher": "请选择老师",
    "class_manager_form_placeholder_select_student": "请选择学生",
    "class_manager_transfer_title_available_teachers": "可用老师",
    "class_manager_transfer_title_available_students": "可用学生",
    "class_manager_transfer_title_class_teachers": "班级老师",
    "class_manager_transfer_title_class_students": "班级学生",
    "class_manager_action_save": "保存",
    "class_manager_action_cancel": "取消",
    "class_manager_msg_save_persons_success": "保存人员成功",
    "class_manager_msg_save_persons_error": "保存人员失败",
    "class_manager_msg_add_teacher_success": "已添加 {{count}} 位老师",
    "class_manager_msg_add_student_success": "已添加 {{count}} 位学生",
    "class_manager_msg_remove_teacher_success": "已移除 {{count}} 位老师",
    "class_manager_msg_remove_teacher_partial_error": "移除老师时部分失败，{{count}} 位老师未能移除",
    "class_manager_msg_remove_student_success": "已移除 {{count}} 位学生",
    "class_manager_confirm_remove_person_title": "确定要移除该人员吗？",
    "class_manager_confirm_remove_person_content": "将从班级中移除 {{name}}",
    "class_manager_action_remove": "移除",
    "class_manager_detail_basic_info": "基本信息",
    "class_manager_detail_teachers": "老师",
    "class_manager_detail_students": "学生",
    "class_manager_no_teachers": "暂无老师",
    "class_manager_no_students": "暂无学生",
    "class_manager_column_id": "ID",
    "class_manager_column_name": "名称",
    "class_manager_column_desc": "描述",
    "class_manager_column_status": "状态",
    "class_manager_column_start_time": "开始时间",
    "class_manager_column_end_time": "结束时间",
    "class_manager_column_time_range": "时间范围",
    "class_manager_column_actions": "操作",
    "class_manager_action_manage_add_stu": "添加学生",
    "class_manager_action_add_teacher": "添加老师",
    "class_manager_form_label_location": "校区",
    "class_manager_form_placeholder_location": "请选择校区",
    "class_manager_form_label_leader_teacher": "班主任",
    "class_manager_form_placeholder_leader_teacher": "请选择班主任",
    "class_manager_form_hint_leader_teacher": "需要先将老师添加到班级后才能设置为班主任",
    "class_manager_form_hint_no_teachers": "班级中暂无老师，请先添加老师",
    "class_manager_detail_location": "校区",
    "class_manager_detail_leader_teacher": "班主任",
    "class_manager_action_manage_teachers_students": "管理老师/学生",
    "class_manager_modal_manage_persons_title": "管理老师和学生：{{name}}",
    "class_manager_form_label_add_teacher": "添加老师",
    "class_manager_form_label_add_student": "添加学生",
    "class_manager_column_subjects": "学科",
    "class_manager_form_placeholder_subjects": "请选择学科",
    "class_manager_action_edit_subjects": "编辑学科",
    "class_manager_action_add_subjects": "添加学科",
    "class_manager_msg_update_subjects_success": "更新学科成功",
    "class_manager_msg_update_subjects_error": "更新学科失败",
    "class_manager_action_add_student": "添加学生",
    "class_manager_action_manage_teacher": "管理老师",
    "class_manager_action_set_homework_bank": "预设作业库",
    "class_manager_action_update_status": "修改状态",
    "class_manager_action_more": "更多",
    "class_manager_modal_manage_students_title": "管理学生：{{name}}",
    "class_manager_modal_manage_teachers_title": "管理老师：{{name}}",
    "class_manager_modal_set_homework_bank_title": "设置预设作业库：{{name}}",
    "class_manager_modal_update_status_title": "修改状态：{{name}}",
    "class_manager_column_subject": "学科",
    "class_manager_column_teacher": "创建人",
    "class_manager_column_description": "描述",
    "class_manager_column_is_leader": "班主任",
    "class_manager_leader_yes": "班主任",
    "class_manager_action_set_leader": "设为班主任",
    "class_manager_action_clear_leader": "取消班主任",
    "class_manager_confirm_clear_leader": "确定要取消该老师的班主任权限吗？",
    "class_manager_msg_set_leader_success": "设置班主任成功",
    "class_manager_msg_set_leader_error": "设置班主任失败",
    "class_manager_msg_clear_leader_success": "已取消班主任",
    "class_manager_msg_clear_leader_error": "取消班主任失败",
    "class_manager_confirm_remove_teacher": "确定要移除该老师吗？",
    "class_manager_action_confirm": "确定",
    "class_manager_form_label_add_homework_bank": "添加作业库",
    "class_manager_form_placeholder_select_homework_bank": "请选择作业库",
    "class_manager_form_placeholder_filter_subject": "筛选学科",
    "class_manager_msg_fetch_homework_bank_error": "获取作业库列表失败",
    "class_manager_msg_add_homework_bank_error": "添加作业库失败",
    "class_manager_msg_remove_homework_bank_success": "移除作业库成功",
    "class_manager_msg_remove_homework_bank_error": "移除作业库失败",
    "class_manager_confirm_remove_homework_bank": "确定要移除该作业库吗？",
    "class_manager_detail_homework_banks": "预设作业库",
    "class_manager_no_homework_banks": "暂无预设作业库",
    "class_manager_form_label_current_status": "当前状态",
    "class_manager_form_label_new_status": "新状态",
    "class_manager_msg_status_no_change": "状态未发生变化",
    "class_manager_action_add": "添加",
    "class_manager_confirm_add_homework_banks": "确定要添加 {{count}} 个作业库吗？",
    "class_manager_confirm_add_teachers": "确定要添加 {{count}} 位老师吗？",
    "class_manager_msg_add_homework_bank_success": "已添加 {{count}} 个作业库",
    "class_manager_msg_add_homework_bank_partial_error": "部分作业库添加失败（{{count}} 个）",
    "class_manager_msg_add_teacher_partial_error": "部分老师添加失败（{{count}} 位）",
    "class_manager_cannot_remove_leader": "班主任不可移除",
    "class_manager_msg_delete_only_disabled_or_end": "只有结束或禁用状态的班级才可以删除",
    "class_manager_selected_banks": "已选择",
    "class_manager_empty_selected_banks": "请从左侧选择作业库",
    "class_manager_title": "班级管理",
    "class_manager_action_clear_selection": "清空选择",
    "class_manager_search_placeholder_homework_bank": "搜索作业库名称",
    "class_manager_action_assign_homework": "下发作业",
    "class_manager_detail_homeworks": "作业",
    "class_manager_modal_assign_homework_title": "下发作业：{{name}}",
    "class_manager_admin_bank_type_auth": "授权题库",
    "class_manager_admin_bank_type_global": "全局题库",
    "class_manager_admin_batch_assign": "批量下发",
    "class_manager_admin_batch_assign_hint": "最多选择 20 个模板",
    "class_manager_admin_assign_success": "下发成功",
    "class_manager_admin_assign_error": "下发失败",
    "class_manager_admin_batch_assign_success": "已成功下发 {{count}} 个作业",
    "class_manager_admin_batch_assign_partial": "成功 {{success}} 个，失败 {{fail}} 个",
    "class_manager_admin_pending_list": "待下发列表",
    "class_manager_admin_confirm_assign": "确认下发",
    "class_manager_admin_homework_name": "作业名称",
    "class_manager_admin_remove_from_list": "移除",
    "class_manager_admin_pending_empty": "请从上方选择作业模板加入待下发列表",
    "class_manager_admin_add_to_list": "加入待下发列表",
};
